<template>
  <div class="navbar navbar-dark navbar-expand-md bg-teal py-1 navbar-static">
    <div class="container-fluid ps-1">
      <div class="navbar-brand">
        <router-link
          to="/home"
          class="d-inline-flex align-items-center"
          title="Home"
        >
          <img
            v-if="user.codColigada == 1"
            src="@/assets/img/senar_branco.png"
            class="h-32px"
            alt="Logo"
          />
          <img
            v-if="user.codColigada == 2"
            src="@/assets/img/faemg_branco.png"
            class="h-32px"
            alt="Logo"
          />
          <img
            v-if="user.codColigada == 3"
            src="@/assets/img/inaes_branco.png"
            class="h-32px"
            alt="Logo"
          />
          <span class="ms-2 text-white fs-lg">
            Sistema de Gestão de Centro de Custo ({{ user.nomeColigada }})
          </span>
        </router-link>
      </div>
      <div class="d-xl-none">
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-navigation"
          aria-expanded="true"
          title="Expandir/Recolher"
        >
          <i class="ph-list" />
        </button>
      </div>
      <div class="navbar-collapse collapse" id="navbar-navigation">
        <ul class="navbar-nav ms-auto">
          <li v-if="user.codColigada == 2" class="nav-item">
            <router-link
              to="/embeds/power-bi"
              class="navbar-nav-link rounded"
              title="Power BI"
            >
              Power BI
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/relatorios"
              class="navbar-nav-link rounded"
              title="Relatórios"
            >
              Relatórios
            </router-link>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ user.codUsuario }}
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                v-if="user.isAdmin"
                to="/admin"
                class="dropdown-item"
                title="Área Administrativa"
              >
                <i class="ph-gear me-2" />Área Administrativa
              </router-link>
              <button class="dropdown-item" @click="logout" title="Sair">
                <i class="ph-sign-out me-2" />Sair
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PATHS from '@/router/routesMap'

export default {
  name: 'Navbar',

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        localStorage.clear()
        this.$router.push(PATHS.BASE_URL)
      })
    },
  },
}
</script>
